import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import table from "./slices/tableSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    table,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
